import axios from "axios";
import getEnv from "../config/env";

const api = axios.create({
  baseURL: getEnv("VUE_APP_API"),
  timeout: 10000
});

export default api;
